import React, { useState } from 'react';
import { SaveIcon, RefreshCwIcon } from 'lucide-react';
import { DataSources } from './DataSources';
export const Settings: React.FC = () => {
  const [scanFrequency, setScanFrequency] = useState('daily');
  const [notificationSettings, setNotificationSettings] = useState({
    email: true,
    browser: false,
    slack: true
  });
  const [aiSettings, setAiSettings] = useState({
    autoClassify: true,
    autoGenerate: false,
    confidenceThreshold: 70
  });
  const [saving, setSaving] = useState(false);
  const handleSaveSettings = () => {
    setSaving(true);
    // Simulate saving settings
    setTimeout(() => {
      setSaving(false);
      alert('Settings saved successfully!');
    }, 1000);
  };
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-1106">
      <div className="flex justify-between items-center mb-6" data-id="element-1107">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1108">Settings</h1>
        <button onClick={handleSaveSettings} disabled={saving} className="inline-flex items-center px-4 py-2 bg-[#f9b30f] hover:bg-[#e0a40e] text-white text-sm font-medium rounded-md disabled:opacity-50" data-id="element-1109">
          {saving ? <>
              <RefreshCwIcon size={16} className="mr-2 animate-spin" data-id="element-1110" />
              Saving...
            </> : <>
              <SaveIcon size={16} className="mr-2" data-id="element-1111" />
              Save Settings
            </>}
        </button>
      </div>
      <DataSources data-id="element-1112" />
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6" data-id="element-1113">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1114">
          Monitoring Settings
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1115">
          <div data-id="element-1116">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1117">
              Scan Frequency
            </label>
            <select value={scanFrequency} onChange={e => setScanFrequency(e.target.value)} className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-[#f9b30f] focus:border-[#f9b30f] sm:text-sm rounded-md" data-id="element-1118">
              <option value="hourly" data-id="element-1119">Every hour</option>
              <option value="daily" data-id="element-1120">Once a day</option>
              <option value="weekly" data-id="element-1121">Once a week</option>
            </select>
            <p className="mt-1 text-sm text-gray-500" data-id="element-1122">
              How often to scan for new intent signals
            </p>
          </div>
          <div data-id="element-1123">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1124">
              Notification Preferences
            </label>
            <div className="space-y-2" data-id="element-1125">
              <label className="flex items-center" data-id="element-1126">
                <input type="checkbox" className="rounded border-gray-300 text-[#f9b30f] focus:ring-[#f9b30f] h-4 w-4" checked={notificationSettings.email} onChange={e => setNotificationSettings({
                ...notificationSettings,
                email: e.target.checked
              })} data-id="element-1127" />
                <span className="ml-2 text-sm text-gray-700" data-id="element-1128">
                  Email notifications
                </span>
              </label>
              <label className="flex items-center" data-id="element-1129">
                <input type="checkbox" className="rounded border-gray-300 text-[#f9b30f] focus:ring-[#f9b30f] h-4 w-4" checked={notificationSettings.browser} onChange={e => setNotificationSettings({
                ...notificationSettings,
                browser: e.target.checked
              })} data-id="element-1130" />
                <span className="ml-2 text-sm text-gray-700" data-id="element-1131">
                  Browser notifications
                </span>
              </label>
              <label className="flex items-center" data-id="element-1132">
                <input type="checkbox" className="rounded border-gray-300 text-[#f9b30f] focus:ring-[#f9b30f] h-4 w-4" checked={notificationSettings.slack} onChange={e => setNotificationSettings({
                ...notificationSettings,
                slack: e.target.checked
              })} data-id="element-1133" />
                <span className="ml-2 text-sm text-gray-700" data-id="element-1134">
                  Slack notifications
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6" data-id="element-1135">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1136">
          AI Assistant Settings
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1137">
          <div data-id="element-1138">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1139">
              Automated Tasks
            </label>
            <div className="space-y-2" data-id="element-1140">
              <label className="flex items-center" data-id="element-1141">
                <input type="checkbox" className="rounded border-gray-300 text-[#f9b30f] focus:ring-[#f9b30f] h-4 w-4" checked={aiSettings.autoClassify} onChange={e => setAiSettings({
                ...aiSettings,
                autoClassify: e.target.checked
              })} data-id="element-1142" />
                <span className="ml-2 text-sm text-gray-700" data-id="element-1143">
                  Automatically classify leads
                </span>
              </label>
              <label className="flex items-center" data-id="element-1144">
                <input type="checkbox" className="rounded border-gray-300 text-[#f9b30f] focus:ring-[#f9b30f] h-4 w-4" checked={aiSettings.autoGenerate} onChange={e => setAiSettings({
                ...aiSettings,
                autoGenerate: e.target.checked
              })} data-id="element-1145" />
                <span className="ml-2 text-sm text-gray-700" data-id="element-1146">
                  Auto-generate outreach messages
                </span>
              </label>
            </div>
          </div>
          <div data-id="element-1147">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1148">
              AI Confidence Threshold ({aiSettings.confidenceThreshold}%)
            </label>
            <input type="range" min="50" max="90" value={aiSettings.confidenceThreshold} onChange={e => setAiSettings({
            ...aiSettings,
            confidenceThreshold: parseInt(e.target.value)
          })} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer" data-id="element-1149" />
            <p className="mt-1 text-sm text-gray-500" data-id="element-1150">
              Minimum confidence level required for AI to take automated actions
            </p>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-1151">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1152">
          Integration Settings
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1153">
          <div data-id="element-1154">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1155">
              CRM Integration
            </label>
            <select className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-[#f9b30f] focus:border-[#f9b30f] sm:text-sm rounded-md" data-id="element-1156">
              <option value="" data-id="element-1157">None</option>
              <option value="salesforce" data-id="element-1158">Salesforce</option>
              <option value="hubspot" data-id="element-1159">HubSpot</option>
              <option value="pipedrive" data-id="element-1160">Pipedrive</option>
            </select>
          </div>
          <div data-id="element-1161">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1162">
              Email Integration
            </label>
            <select className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-[#f9b30f] focus:border-[#f9b30f] sm:text-sm rounded-md" data-id="element-1163">
              <option value="" data-id="element-1164">None</option>
              <option value="gmail" data-id="element-1165">Gmail</option>
              <option value="outlook" data-id="element-1166">Outlook</option>
            </select>
          </div>
          <div data-id="element-1167">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1168">
              Calendar Integration
            </label>
            <select className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-[#f9b30f] focus:border-[#f9b30f] sm:text-sm rounded-md" data-id="element-1169">
              <option value="" data-id="element-1170">None</option>
              <option value="gcal" data-id="element-1171">Google Calendar</option>
              <option value="outlook" data-id="element-1172">Outlook Calendar</option>
            </select>
          </div>
          <div data-id="element-1173">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1174">
              Messaging Integration
            </label>
            <select className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-[#f9b30f] focus:border-[#f9b30f] sm:text-sm rounded-md" data-id="element-1175">
              <option value="" data-id="element-1176">None</option>
              <option value="slack" data-id="element-1177">Slack</option>
              <option value="teams" data-id="element-1178">Microsoft Teams</option>
            </select>
          </div>
        </div>
      </div>
    </div>;
};